import TeaserCard, { TeaserFields } from "components/ui/TeaserCard";

export type GridTeaserElementProps = {
    fields: TeaserFields;
};

export const GridTeaserElementColumns2 = (props: GridTeaserElementProps) => {
    return <TeaserCard variant="columns2" fields={props.fields} />;
};

export const GridTeaserElementColumns3 = (props: GridTeaserElementProps) => {
    return <TeaserCard variant="columns3" fields={props.fields} />;
};

export const GridTeaserElementImageRight = (props: GridTeaserElementProps) => {
    return <TeaserCard variant="imageRight" fields={props.fields} />;
};

export const GridTeaserElementImageLeft = (props: GridTeaserElementProps) => {
    return <TeaserCard variant="imageLeft" fields={props.fields} />;
};
